import { render, staticRenderFns } from "./filter-manager.vue?vue&type=template&id=8b5d8c1a"
import script from "./filter-manager.vue?vue&type=script&lang=js"
export * from "./filter-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports